import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const CANONICAL_ORIGIN = 'https://www.slammmm.com';

// Keeps <link rel="canonical"> in sync with the page that is actually open, on every
// route change. Query string and hash are dropped, and a trailing slash is removed
// (except for the home page), so the canonical is always that page's own URL.
const Canonical: React.FC = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    const path = pathname.length > 1 ? pathname.replace(/\/+$/, '') : '/';

    let tag = document.querySelector('link[rel="canonical"]') as HTMLLinkElement | null;
    if (!tag) {
      tag = document.createElement('link');
      tag.setAttribute('rel', 'canonical');
      document.head.appendChild(tag);
    }
    tag.setAttribute('href', `${CANONICAL_ORIGIN}${path}`);
  }, [pathname]);

  return null;
};

export default Canonical;
